import type { Enemy } from '../entities/Enemy';
import type { Player } from '../entities/Player';
import type { AABB } from '../core/Collision';

export class VisionSystem {
  private walls: AABB[] = [];

  setWalls(walls: AABB[]): void {
    this.walls = walls;
  }

  update(enemies: Enemy[], player: Player): void {
    for (const enemy of enemies) {
      if (!enemy.isAlive()) continue;

      if (enemy.canSeePlayer(player, this.walls)) {
        enemy.onPlayerSpotted(player.position);
      }
    }
  }

  isPlayerInVision(enemy: Enemy, player: Player): boolean {
    return enemy.canSeePlayer(player, this.walls);
  }
}
